import React from 'react';
import gtm from 'general/js/gtm';
import { LazyImage } from '../../../project/lazy-image';

const LeaderboardWidgetFooter = ({ fullLeaderboardLink, targetsConfig, patronLogo }) => {
    const targetAttr = targetsConfig ? '_blank' : null;
    const targetUrl = targetsConfig ? targetsConfig.allResultsUrl : fullLeaderboardLink;

    return (
        <div className="leaderboard-widget__footer">
            <a
                className="leaderboard-widget__full-leaderboard-link"
                href={targetUrl}
                target={targetAttr}
                rel="noopener noreferrer"
                onClick={() => {
                    gtm.push(
                        'Leaderboard',
                        'Click',
                        `Full Leaderboard > ${window.location.href}`
                    );
                }}
            >Full leaderboard</a>
            <div className="leaderboard-widget__patron of-contain">
                <LazyImage image={patronLogo} />
            </div>
        </div>
    );
};

export default LeaderboardWidgetFooter;
